import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import styled from 'styled-components';

import LogoJabil from '../resources/images/partners-jabil.png';
import LogoTEKTELIC from '../resources/images/partners-tek.svg';

const PartnersStyle = styled.div`
	margin-top: 2.5rem;
	margin-bottom: 9.375rem;
	position: relative;
	z-index: 9;
	
	h2 {
		margin-bottom: 1.875rem;
	}
	
	.partners-item {
		margin-bottom: 3.75rem;
		h4 {
			font-size: 0.9375rem;
			font-weight: 500;
		}
		p {
			opacity: 0.5;
		}
	}
	
	.partners-logo {
		width: auto;
		height: 30px;
		margin: auto;
		margin-bottom: 1.875rem;
	}
`;

class Partners extends Component {

	render() {

		return (
			<PartnersStyle className="text-center">
					<div className="container">
						<div className="row">
							<div className="columns medium-8 small-centered">
								<h2>{ this.props.partners.title }</h2>
							</div>
						</div>
						<div className="row">
							<div className="columns medium-6">
								<div className="partners-item">
									<img src={ LogoJabil } className="partners-logo" alt="Jabil Logo" />
									<h4>{ this.props.partners.jabil.title }</h4>
									<p className="small">{ this.props.partners.jabil.caption }</p>
								</div>
							</div>
							<div className="columns medium-6">
								<div className="partners-item">
									<img src={ LogoTEKTELIC } className="partners-logo" alt="TEKTELIC Logo" />
									<h4>{ this.props.partners.tektelic.title }</h4>
									<p className="small">{ this.props.partners.tektelic.caption }</p>
								</div>
							</div>
						</div>
					</div>
			</PartnersStyle>
		)
	}
}

export default withRouteData(Partners)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Partners.js